import "./app.css";
import { ErrorBoundary, LocationProvider, Route, Router } from "preact-iso";
import hydrate from "preact-iso/hydrate";
import { Toaster } from "react-hot-toast";
import { NotFound } from "./notFound.tsx";
import { isDarkMode, routes, useTheme, WithHeader } from "./routes.tsx";
import { useEffect, useState } from "preact/hooks";

const App = () => {
  useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <>
      {mounted && (
        <Toaster
          toastOptions={{
            style: {
              background: isDarkMode.value ? "#23262f" : "#ffffff",
              color: isDarkMode.value ? "#f1f1f3" : "#1a1a2e",
              border: isDarkMode.value ? "1px solid #333" : "1px solid #e0e0e5",
              fontSize: 16,
            },
            iconTheme: {
              primary: isDarkMode.value ? "#7ec7ff" : "#007aff",
              secondary: isDarkMode.value ? "#23262f" : "#ffffff",
            },
          }}
          position="top-center"
          theme={isDarkMode.value ? "dark" : "light"}
        />
      )}
      <div
        className="flex flex-col flex-grow font-sans"
        style={{ minHeight: "100vh", width: "100%" }}
      >
        <ErrorBoundary>
          <Router>
            {routes.map(({ path, component }) => (
              <Route path={path} component={component} />
            ))}
            <Route default component={WithHeader(NotFound)} />
          </Router>
        </ErrorBoundary>
      </div>
    </>
  );
};

export const App_ = () => (
  <LocationProvider>
    <App />
  </LocationProvider>
);

hydrate(<App_ />);
